export type QuantityDisplay = 'normal' | 'abbr'

function abbrSuffix(value: number, divisor: number, suffix: string): string {
  const n = value / divisor
  // strip trailing zeros: 1.30 → "1.3", 1.00 → "1"
  const s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2).replace(/\.?0+$/, '')
  return s + suffix
}

export function formatCompact(value: number, _fractionDigits: number): string {
  if (value >= 1_000_000_000) return abbrSuffix(value, 1_000_000_000, 'B')
  if (value >= 1_000_000) return abbrSuffix(value, 1_000_000, 'M')
  return abbrSuffix(value, 1_000, 'K')
}

export function formatNormal(value: number, fractionDigits: number): string {
  return value.toLocaleString('en-US', {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: 0,
  })
}

export function formatQty(value: number, fractionDigits: number, display: QuantityDisplay): string {
  return display === 'abbr'
    ? formatCompact(value, fractionDigits)
    : formatNormal(value, fractionDigits)
}
